import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';

export default function EnterPackerDialog(props) {

    const classes = useStyles();
    const [packer, setPacker] = useState(null)
    const [disableConfirm, setDisableConfirm] = useState(true)
    const { t } = useTranslation();

    const packerChanged = (event) => {
        setPacker(event.target.value)

        if(event.target.value !== ""){
            setDisableConfirm(false);
        }
    }

    return (
        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            onClose = {props.closeDialog}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {props.dialogTitle}
            </DialogTitle>
            <DialogContent >
                <div className={classes.label}>{t("Packer")}</div>
                <TextField id="outlined-search" size="small" label="" type="search" variant="outlined" value={packer} className={classes.uiTextField} onChange={(e) => packerChanged(e)} />
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button disabled={disableConfirm} className={classes.okButton} autoFocus onClick={() => props.action(packer)}>
                        {t("OK")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({
    dialogContainer: {
        margin: "auto",
        "& > div > div": {
            backgroundImage: 'linear-gradient(#EFEFEF,#FFFFFF)'
        },
    },
    buttons: {
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: "20px"
    },
    okButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "110px",
        marginBottom: "30px",
        marginTop: "20px",
        float: "left"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        fontSize: "32px !important",
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "50px",
        marginBottom: "20px",
    },
    uiTextField: {
        backgroundColor: "white",
        marginRight: "auto",
        marginLeft: "auto"
    },
    label: {
        color: "#000000",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: "5px"
    },
}));
